module.exports = __webpack_public_path__ + "grootstatic/media/banner-hi.ac98751d.svg";